import coverImg from '../../../media/papers/allosteric3/cover.jpeg';
import allosteric3PDF from '../../../media/papers/allosteric3/allosteric3.pdf';

const allosteric3PaperData = {
    name: "Decoding Allosteric Grammar with Explainable AI",
    displayTitle: "Decoding Allosteric Grammar\nwith Explainable AI",
    category: "Computational Biology",
    tagline: "PLMs and Energy Landscape Analysis Reveal Neutral Frustration at Allosteric Sites Across Human Kinases",
    year: "2026",
    format: "bioRxiv",
    heroImage: coverImg,

    description: "Allosteric regulation enables protein kinases to integrate cellular signals, yet the energetic principles governing regulatory binding sites remain incompletely understood. This work uses protein language models as diagnostic probes rather than predictive endpoints, combined with frustration analysis across 453 human kinases. Orthosteric ATP pockets are detected with high confidence; allosteric sites are not. Orthosteric catalytic sites reside in minimally frustrated regions, while allosteric sites enrich in neutral frustration zones with diffuse, context-dependent predictions. Atomic-resolution analysis of ABL kinase across conformational states provides mechanistic validation.",

    highlight: "Across 453 kinases, PLM detectability mirrors energetic embedding: minimally frustrated orthosteric pockets versus neutrally frustrated allosteric regions, indicating the blind spot is encoded in the energy landscape.",

    techStack: [
        "Protein Language Models (PLMs)",
        "Energy Landscape Theory",
        "Local Frustration Analysis",
        "Human Kinases (n=453)",
        "Explainable AI",
        "Structural Biology",
        "Computational Biology"
    ],

    documents: [
        {
            type: 'pdf',
            src: allosteric3PDF,
            title: 'Read Full Paper (PDF)',
            alt: 'Full research paper'
        },
        {
            type: 'link',
            src: 'https://www.biorxiv.org/content/10.64898/2026.03.21.713412v1',
            title: 'View on bioRxiv',
            alt: 'Full paper preprint'
        }
    ],
    documentTitle: "Publication"
};

export default allosteric3PaperData;
